/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { VueHeadMixin, createHead } from '@unhead/vue'
import VueCookies from 'vue-cookies'

import { initSentry } from '@/plugins/sentry'
import router from '@/router'
import store from '@/store'

import { kitLibrary } from './font-awesome-libraries/closd-kit-library'
import { duotoneLibrary } from './font-awesome-libraries/duotone-library'
import { lightLibrary } from './font-awesome-libraries/light-library'
import { regularLibrary } from './font-awesome-libraries/regular-library'
import { solidLibrary } from './font-awesome-libraries/solid-library'
import i18n from './i18n'
import createVuetify from './vuetify'
import './axios'

// Types
import type { App } from 'vue'

library.add(...duotoneLibrary)
library.add(...lightLibrary)
library.add(...regularLibrary)
library.add(...solidLibrary)
library.add(...kitLibrary)

export async function registerPlugins (app: App) {
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.component('font-awesome-layers', FontAwesomeLayers)

  initSentry(app, router)
  const head = createHead()

  const vuetify = await createVuetify()

  app
    .use(store)
    .use(i18n)
    .use(vuetify)
    .use(router)
    .use(VueCookies)
    .use(head)
    .mixin(VueHeadMixin)
}
